var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitorlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 710.935,
    height: 648.761,
    viewBox: "0 0 710.935 648.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6704",
    x: 236.866,
    y: 135.611,
    width: 138.128,
    height: 140.557,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6737",
    x: 347.311,
    y: 5.872,
    width: 141.458,
    height: 129.192,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6752",
    x: 426.966,
    y: 139.757,
    width: 164.514,
    height: 189.965,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7444",
    "data-name": "Group 7444",
    transform: "translate(-1056.422 -288.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(1056.422 527.359)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_4_",
    cx: 355.468,
    cy: 205.194,
    rx: 355.468,
    ry: 205.194,
    fill: "#226bab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7093",
    "data-name": "Group 7093",
    transform: "translate(64 90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 992.42, 198.99)",
    filter: "url(#Path_6704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6704-2",
    "data-name": "Path 6704",
    d: "M1466.028,525.982V628.776c0,5.463-3.716,9.882-8.31,9.882H1354.21c-4.594,0-8.31-4.419-8.31-9.882V525.982c0-5.463,3.716-9.882,8.31-9.882h103.508C1462.312,516.14,1466.028,520.559,1466.028,525.982Z",
    transform: "translate(-1100.03 -374.49)",
    fill: "#fff",
    opacity: 0.95
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6969",
    "data-name": "Group 6969",
    transform: "translate(1265.289 373.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6705",
    "data-name": "Path 6705",
    d: "M1426.4,647.607c-2.242-5.92-7.6-8.619-10.143-9.468-.892-.3-2.525-.827-4.223-1.371-3.069-.979-6.4-2.068-6.4-2.068h-10.556s-3.656,1.219-7.552,2.59h0c-3.591,1.262-7.357,2.634-8.619,3.265-2.656,1.328-7.117,10.8-8.031,11.884a82.635,82.635,0,0,0-4.571,8.38h11.383c1.2-2.068,2.133-3.678,2.133-3.678s.718,1.589,1.589,3.678h36.458c.566-2.416.936-5.485.936-5.485s1.959,2.655,4.092,5.485H1433.4C1430.835,656.531,1427.657,650.959,1426.4,647.607Z",
    transform: "translate(-1366.3 -603.784)",
    fill: "#385369"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6965",
    "data-name": "Group 6965",
    transform: "translate(25.422 1.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6706",
    "data-name": "Path 6706",
    d: "M1492.98,501.022s8.271,1.306,7.009,14.235-8.554,11.862-9.033,11.862c-.479-.022-7.313.239-7.857-15.541C1483.1,511.557,1482.881,499.89,1492.98,501.022Z",
    transform: "translate(-1483.098 -500.945)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6966",
    "data-name": "Group 6966",
    transform: "translate(41.963 12.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6707",
    "data-name": "Path 6707",
    d: "M1559.576,548.393s.914-.958,1.241.022-1.241,5.333-1.284,5.55c0,0-.174.37-.392.174C1558.923,553.9,1559.576,548.393,1559.576,548.393Z",
    transform: "translate(-1559.096 -547.974)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6967",
    "data-name": "Group 6967",
    transform: "translate(24.367 11.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6708",
    "data-name": "Path 6708",
    d: "M1479.548,547.512s-.892-.979-1.241-.022c-.348.979,1.11,5.354,1.176,5.572,0,0,.152.392.37.174C1480.092,553.04,1479.548,547.512,1479.548,547.512Z",
    transform: "translate(-1478.254 -547.07)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6968",
    "data-name": "Group 6968",
    transform: "translate(24.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6709",
    "data-name": "Path 6709",
    d: "M1496.778,507.1l-1.175,1.589a30.3,30.3,0,0,0-.152-4c-.2-.544-.479-2.2-.631-2.59s-7.1-2.329-13.212.566c0,0,.261,2.5-.327,2.721s-.3,4.07-.3,4.07l-.979-1.088s-1.48-9.947-1.11-10.97c.37-1.045,1.545-7.27,14.1-3.57,0,0,3.918-.827,4.7,1.872C1498.476,498.349,1496.778,507.1,1496.778,507.1Z",
    transform: "translate(-1478.827 -492.66)",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6710",
    "data-name": "Path 6710",
    d: "M1487.939,605.092c0-.022-1.067-.522-1.067-.522-.522-1.154-.13-6.007-.13-6.007s-10.513-2.677-10.23-.631c.3,2.046-.914,6.813-.914,6.813l-5.4,2.677s5.746,15.432,12.363,13.451c6.617-2,9.1-14.017,9.1-14.017Z",
    transform: "translate(-1447.586 -574.416)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6711",
    "data-name": "Path 6711",
    d: "M1500,610.418a6.237,6.237,0,0,0,4.636,2.2c1.937,0,3.33-.544,5.246-2.416a5.518,5.518,0,0,1-5.246,3.9C1504.658,614.074,1501.458,614.488,1500,610.418Z",
    transform: "translate(-1470.899 -584.617)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7092",
    "data-name": "Group 7092",
    transform: "translate(1256.289 364.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6751",
    "data-name": "Path 6751",
    d: "M1973.421,323.232v1.784h10.45v9.813h1.784V323.264h-12.234ZM1902.532,334.8h1.784v-9.813h10.45V323.2h-12.2v11.6Zm81.339,50.562v9.813h-10.45v1.784h12.2V385.391h-1.752Zm-79.587,0H1902.5v11.565h12.2V395.14h-10.45v-9.781Z",
    transform: "translate(-1902.5 -323.2)",
    fill: "#4598e6"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2978",
    "data-name": "Ellipse 2978",
    cx: 68,
    cy: 17.5,
    rx: 68,
    ry: 17.5,
    transform: "translate(1177.289 842.596)",
    fill: "#242424",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7026",
    "data-name": "Group 7026",
    transform: "translate(1187.289 463.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6974",
    "data-name": "Group 6974",
    transform: "translate(36.211 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6973",
    "data-name": "Group 6973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6972",
    "data-name": "Group 6972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6971",
    "data-name": "Group 6971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6970",
    "data-name": "Group 6970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6712",
    "data-name": "Path 6712",
    d: "M1289.239,874.833s12.774,6.266,9.6,23.258-4.539,19.281-1,25.909,7.713,34.988,4.539,40.33c-3.173,5.383-39.366-23.579-44.347-47.882-5.021-24.3,3.173-35.108,6.066-39.125C1266.945,873.266,1277.951,869.128,1289.239,874.833Z",
    transform: "translate(-1256.434 -872.034)",
    fill: "#242424"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6975",
    "data-name": "Group 6975",
    transform: "translate(61.199 361.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6713",
    "data-name": "Path 6713",
    d: "M1321.636,1808.329h2.892v-13.658a38.983,38.983,0,0,1,9.239,9c3.575,5.222,8.476,4.78,15.907,4.459,7.471-.321,7.11-3.334,6.467-7.552-.683-4.218-8.235-5.584-10.685-6.226-2.45-.683-7.994-10.243-9.8-12.573a31.3,31.3,0,0,1-3.736-6.226s-1.406-5.664-8.275,0c-6.909,5.664-4.9,16.59-4.137,17.594S1321.636,1808.329,1321.636,1808.329Z",
    transform: "translate(-1318.64 -1773.033)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6976",
    "data-name": "Group 6976",
    transform: "translate(64.597 362.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6714",
    "data-name": "Path 6714",
    d: "M1341.28,1795.757c2.571,1.687,9.239,0,9.239,0-1.888-2.45-13.537-18.8-13.537-18.8-7.07-4.137-9.882,1.567-9.882,1.567C1329.992,1779.408,1338.709,1794.11,1341.28,1795.757Z",
    transform: "translate(-1327.1 -1775.453)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6980",
    "data-name": "Group 6980",
    transform: "translate(152.769 123.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6979",
    "data-name": "Group 6979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6978",
    "data-name": "Group 6978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6977",
    "data-name": "Group 6977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6715",
    "data-name": "Path 6715",
    d: "M1547.042,1187.673s4.62.884,6.226-1.285c1.366-1.848,4.419-3.254,5.383-3.7,1.285-.6,4.5-3.856,5.222-2.25s-5.061,5.624-6.106,6.708,5.7,1.567,6.829,2.611c1.165,1.044-.281,12.171-4.861,11.288s-8.918-4.82-9.761-4.82a31.391,31.391,0,0,1-3.374-.482Z",
    transform: "translate(-1546.6 -1180.002)",
    fill: "#ffbe9d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6984",
    "data-name": "Group 6984",
    transform: "translate(166.065 133.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6983",
    "data-name": "Group 6983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6982",
    "data-name": "Group 6982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6981",
    "data-name": "Group 6981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6716",
    "data-name": "Path 6716",
    d: "M1583.4,1203.2s13.858,3.575,14.582,4.579.482,1.768-.844,1.486-13.5-3.053-13.5-3.053,15.666,6.99,16.469,7.672c.442.4.08,1.888-.643,1.767-.723-.08-16.67-6.146-16.67-6.146s14.622,6.548,15.1,7.351a1.119,1.119,0,0,1-1.406,1.526c-1.125-.4-15.064-5.744-15.064-5.744s10.364,5.423,10.364,6.347c0,.562-.241,1.808-2.892.321-2.611-1.486-9.2-4.338-9.2-4.338Z",
    transform: "translate(-1579.7 -1203.2)",
    fill: "#ffbe9d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6985",
    "data-name": "Group 6985",
    transform: "translate(25.829 373.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6717",
    "data-name": "Path 6717",
    d: "M1231.437,1825.765h1.767v-10a21.71,21.71,0,0,1,4.62,8.034c1.446,4.78,6.628,6.226,14.541,5.985s8.034-3.334,7.351-8.034c-.683-4.66-7.351-7.11-7.351-7.11-3.013-2.691-10.484-13.738-10.484-13.738a10.406,10.406,0,0,0-8.556,1.767c-3.776,3.013-2.571,9.882-2.49,11.649C1230.995,1816.084,1231.437,1825.765,1231.437,1825.765Z",
    transform: "translate(-1230.589 -1800.631)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6986",
    "data-name": "Group 6986",
    transform: "translate(15.938 155.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6718",
    "data-name": "Path 6718",
    d: "M1222.168,1263.119s-9.4,12.252-11.97,26.793,1.526,63.307,1.406,70.457c-.12,7.19-6.789,25.066-5.463,38.563s6.588,80.861,6.588,80.861l14.421-2.852s-.844-68.65,0-74.314,2.531-26.391,2.852-28.721,21.209-63.709,21.209-74.193S1244.864,1246.047,1222.168,1263.119Z",
    transform: "translate(-1205.966 -1259.171)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6987",
    "data-name": "Group 6987",
    transform: "translate(47.075 161.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6719",
    "data-name": "Path 6719",
    d: "M1315.865,1276.331s15.465,59.049,17.313,67.244,4.5,14.943,4.5,18.4c0,8.074-3.013,21.009-3.013,21.009l-19.643,94H1296.3s10.444-56.4,10.725-67.4c.281-11.047,8.8-26.753,7.11-31.413s-26.874-58.607-26.874-58.607S1268.143,1259.179,1315.865,1276.331Z",
    transform: "translate(-1283.48 -1273.264)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6988",
    "data-name": "Group 6988",
    transform: "translate(28.565 373.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6720",
    "data-name": "Path 6720",
    d: "M1256.44,1815.038l-10.484-13.738-8.556,1.768a38.2,38.2,0,0,0,6.467,10.765C1248.808,1819.3,1256.44,1815.038,1256.44,1815.038Z",
    transform: "translate(-1237.4 -1801.3)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6990",
    "data-name": "Group 6990",
    transform: "translate(67.44 63.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6989",
    "data-name": "Group 6989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6721",
    "data-name": "Path 6721",
    d: "M1339.81,1031.1a19.284,19.284,0,0,1,11.207,5.784c4.82,5.182,9.36,13.417,10.6,16.148s18.96,28.279,19.884,28.842,9.8,3.535,15.706,5.543c9.078,3.053,27.315,9.681,27.315,9.681l-3.615,11.448s-34.3-11.207-42.861-13.336c-10.484-2.571-34.666-33.582-34.666-33.582S1325.309,1040.5,1339.81,1031.1Z",
    transform: "translate(-1334.177 -1031.1)",
    fill: "#ed7d2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6992",
    "data-name": "Group 6992",
    transform: "translate(17.639 58.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6991",
    "data-name": "Group 6991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6722",
    "data-name": "Path 6722",
    d: "M1254.467,1019.257s8.275,3.9,11.127,4.459,14.019,15.023,15.947,20.326c1.968,5.262,0,13.216-4.017,22.495s-.241,12.412-2.049,21.692c-1.848,9.279-1.245,44.066-.884,49.248s-53.707,12.975-64.392,3.575c0,0,7.231-31.332,15.787-40.29,1.848-1.928,1.647-14.823.4-18.036s-15.505-27.195-15.505-27.195-1.044-24.343,5.182-29.163c5.383-4.178,20.085-5.664,22.736-6.588C1241.412,1018.856,1249.084,1018.454,1254.467,1019.257Z",
    transform: "translate(-1210.2 -1018.826)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6994",
    "data-name": "Group 6994",
    transform: "translate(46.24 38.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6993",
    "data-name": "Group 6993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6723",
    "data-name": "Path 6723",
    d: "M1301.043,979.341s-.241,2.29-.522,5.342c-.12,1.205-.241,2.571-.321,3.937a94.8,94.8,0,0,0-.442,10.806s-8.6,8.6-18.358-10.042c0,0,4.1-7.672,1-18.157C1279.271,960.743,1301.043,979.341,1301.043,979.341Z",
    transform: "translate(-1281.4 -968.023)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6995",
    "data-name": "Group 6995",
    transform: "translate(85.847 88.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6724",
    "data-name": "Path 6724",
    d: "M1384.057,1113.293s2.049-13.738-.121-22.093c0,0,0,7.19-3.937,17.393Z",
    transform: "translate(-1380 -1091.2)",
    fill: "#d86200"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6996",
    "data-name": "Group 6996",
    transform: "translate(39.612 59.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6725",
    "data-name": "Path 6725",
    d: "M1264.9,1022.167s5.905,17.434,22.133,16.148,7.672-14.742,7.672-14.742-4.057-2.33-5.182-2.531-17.916-.442-17.916-.442Z",
    transform: "translate(-1264.9 -1020.6)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6997",
    "data-name": "Group 6997",
    transform: "translate(69.418 62.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6726",
    "data-name": "Path 6726",
    d: "M1339.1,1028.1s8.476,23.5,8.476,47.44.683,62.946,3.655,75.278,11.408,50.413,11.408,50.413l6.628-3.414s-15.907-60.817-17.112-65.2.924-50.694,2.049-54.59,5.985-21.129,5.222-25.949c-.964-6.025-6.588-14.983-15.706-22.656Z",
    transform: "translate(-1339.1 -1028.1)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6998",
    "data-name": "Group 6998",
    transform: "translate(6.994 60.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6727",
    "data-name": "Path 6727",
    d: "M1219.531,1022.7a246.811,246.811,0,0,1,7.954,38.563c2.691,21.651-8.195,122.156-15.505,144.972l-28.279-4.579s6.106-71.02,14.34-83.954,10.886-24.383,1.968-51.337c-8.918-26.994,3.9-40.33,3.9-40.33S1217.041,1022.981,1219.531,1022.7Z",
    transform: "translate(-1183.7 -1022.7)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6999",
    "data-name": "Group 6999",
    transform: "translate(0.888 109.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6728",
    "data-name": "Path 6728",
    d: "M1240.926,1167.1l-34.265,59.411-38.161-22.053,32.818-60.254Z",
    transform: "translate(-1168.5 -1144.2)",
    fill: "#3a3a3a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7000",
    "data-name": "Group 7000",
    transform: "translate(4.865 113.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6729",
    "data-name": "Path 6729",
    d: "M1242.752,1175.986l-30.489,52.783-33.863-19.562,29.163-53.506Z",
    transform: "translate(-1178.4 -1155.7)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7001",
    "data-name": "Group 7001",
    transform: "translate(43.749 117.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6730",
    "data-name": "Path 6730",
    d: "M1289.42,1177.109l2.129-3.7-13.7-7.913-2.651,3.414Z",
    transform: "translate(-1275.2 -1165.5)",
    fill: "#3a3a3a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7007",
    "data-name": "Group 7007",
    transform: "translate(40.616 153.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7006",
    "data-name": "Group 7006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7005",
    "data-name": "Group 7005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7004",
    "data-name": "Group 7004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7003",
    "data-name": "Group 7003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7002",
    "data-name": "Group 7002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6731",
    "data-name": "Path 6731",
    d: "M1283.106,1271.938a7.371,7.371,0,0,1-2.25-.322s-1.205-.683-2.089-1.125c-.281-.121-.522-.241-.683-.321a13.386,13.386,0,0,1-3.816-1.607c-1.526-1.045-6.869-7.271-6.869-7.271l2.531-3.856,1.848-3.937s11.288.723,12.814,1.526a3.547,3.547,0,0,1,.4.241,14.307,14.307,0,0,1,2.37,2.45c.2.2,2.25,2.169,2.169,3.013a2.688,2.688,0,0,1-1.366,2.33,6.69,6.69,0,0,1-1.406,3.374,4.129,4.129,0,0,1-1.969,3.053S1284.352,1271.616,1283.106,1271.938Z",
    transform: "translate(-1267.4 -1253.5)",
    fill: "#ffbe9d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7009",
    "data-name": "Group 7009",
    transform: "translate(0 63.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7008",
    "data-name": "Group 7008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6732",
    "data-name": "Path 6732",
    d: "M1199.353,1030.583s-10.4-2.973-16.389,8.476c-5.985,11.488-5.945,16.389-6.749,21.973-.763,5.3-4.138,19.723-4.5,21.25-.362,1.486-8.034,19.281-4.5,25.508,3.535,6.266,39.607,24.664,39.366,26.03s6.226-13.9,6.226-13.9-14.582-8.114-16.992-10.645c-3.9-4.057-12.051-8.436-10.4-13.5,1.968-5.945,7.913-25.909,9.279-28.842C1196.139,1064,1208.15,1034.318,1199.353,1030.583Z",
    transform: "translate(-1166.289 -1030.235)",
    fill: "#ed7d2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7014",
    "data-name": "Group 7014",
    transform: "translate(42.712 4.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7013",
    "data-name": "Group 7013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7012",
    "data-name": "Group 7012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7011",
    "data-name": "Group 7011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7010",
    "data-name": "Group 7010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6733",
    "data-name": "Path 6733",
    d: "M1297.074,882.9s18.558,5.825,8.476,37.84-35.389-3.7-32.738-23.218C1275.423,878.037,1297.074,882.9,1297.074,882.9Z",
    transform: "translate(-1272.618 -882.359)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7019",
    "data-name": "Group 7019",
    transform: "translate(41.239 1.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7018",
    "data-name": "Group 7018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7017",
    "data-name": "Group 7017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7016",
    "data-name": "Group 7016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7015",
    "data-name": "Group 7015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6734",
    "data-name": "Path 6734",
    d: "M1305.244,897.736A41.746,41.746,0,0,1,1280.62,907.9s-5.945,6.949-6.387,9.681c0,0-13.778-23.459,3.173-37.518C1294.278,866,1311.43,891.951,1305.244,897.736Z",
    transform: "translate(-1268.952 -875.939)",
    fill: "#242424"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7024",
    "data-name": "Group 7024",
    transform: "translate(46.629 27.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7023",
    "data-name": "Group 7023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7022",
    "data-name": "Group 7022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7021",
    "data-name": "Group 7021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7020",
    "data-name": "Group 7020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6735",
    "data-name": "Path 6735",
    d: "M1288.808,947.561c-.121-2.33-1.567-7.632-5.021-6.146s.2,12.292,2.49,11.609C1286.318,953.024,1289.089,953.064,1288.808,947.561Z",
    transform: "translate(-1282.368 -941.156)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7025",
    "data-name": "Group 7025",
    transform: "translate(51.341 46.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6736",
    "data-name": "Path 6736",
    d: "M1308.079,996.517c-.12,1.205-.241,2.571-.321,3.937,0,0-8.195-.482-13.658-12.653C1294.461,988.322,1300.447,997.119,1308.079,996.517Z",
    transform: "translate(-1294.1 -987.8)",
    fill: "#a77860"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7091",
    "data-name": "Group 7091",
    transform: "translate(-23.9 66.049)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1080.32, 222.94)",
    filter: "url(#Path_6737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6737-2",
    "data-name": "Path 6737",
    d: "M1947.4,371.392h-92.745a15.365,15.365,0,0,1-15.357-15.357V275.557a15.365,15.365,0,0,1,15.357-15.357H1947.4a15.365,15.365,0,0,1,15.356,15.357v80.479A15.365,15.365,0,0,1,1947.4,371.392Z",
    transform: "translate(-1482.99 -248.33)",
    fill: "#fff",
    opacity: 0.95
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6414",
    "data-name": "Rectangle 6414",
    width: 9.781,
    height: 1.816,
    transform: "translate(1492.995 338.003)",
    fill: "#4598e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7043",
    "data-name": "Group 7043",
    transform: "translate(1474.382 222.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7030",
    "data-name": "Group 7030",
    transform: "translate(10.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7029",
    "data-name": "Group 7029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7028",
    "data-name": "Group 7028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6738",
    "data-name": "Path 6738",
    d: "M2013.006,225.059s7.9,4.333,5.384,14.974-3.473,12.075-1.434,16.376,3.823,22.334,1.657,25.647-24.182-16.089-26.635-31.605,3.059-22.111,5-24.564S2006.06,221.109,2013.006,225.059Z",
    transform: "translate(-1991.36 -222.936)",
    fill: "#242424"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7031",
    "data-name": "Group 7031",
    transform: "translate(24.455 39.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6739",
    "data-name": "Path 6739",
    d: "M2057.241,397.966H2048.8c-.415-4.174-.8-7.073-.7-7.487.127-.7-8.411-23.067-9.207-24.946-.8-1.848-3.919-6.818-4.333-11.47-.414-4.683,5.671-6.563,5.671-6.563,8.22,1.466,11.024,12.84,11.024,12.84s3.441,23.067,5.193,29.566A41.032,41.032,0,0,1,2057.241,397.966Z",
    transform: "translate(-2034.537 -347.5)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6740",
    "data-name": "Path 6740",
    d: "M2053.3,361.561l-12.585,5.289s-11.565-28.706-1.88-25.488S2052.85,350.569,2053.3,361.561Z",
    transform: "translate(-2010.374 -303.46)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7032",
    "data-name": "Group 7032",
    transform: "translate(3.968 36.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6741",
    "data-name": "Path 6741",
    d: "M2006.386,371.656c-.383,2.836-1.88,12.935-1.53,15.675.064.446.255,1.5.51,2.9h-30.331c.8-2.867,1.529-5.416,1.975-6.914,1.466-4.875.064-6.181-.669-10.1a79.577,79.577,0,0,0-2.421-7.71c-.382-1.083-.765-2.23-1.115-3.377a69.542,69.542,0,0,1-2.326-10.832c-1.816-11.661,7.137-12.776,7.137-12.776,3.345-.605,9.176-2.421,9.176-2.421l9.112,1.912a9.545,9.545,0,0,1,2.135,1.274h0a18.486,18.486,0,0,1,2.039,1.784,55.265,55.265,0,0,1,4.97,7.169c.605.988,1.211,2.007,1.784,2.995,1.848,3.218,3.186,5.8,3.122,8.73C2009.955,362.8,2006.769,368.82,2006.386,371.656Z",
    transform: "translate(-1970.237 -336.1)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6742",
    "data-name": "Path 6742",
    d: "M2020.614,338.031s5.7,9.781,3.6,10.514c-2.135.733-13.318-1.752-17.714-10.96C2006.5,337.585,2013.86,334.24,2020.614,338.031Z",
    transform: "translate(-1990.978 -300.129)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6743",
    "data-name": "Path 6743",
    d: "M2023.861,315.625s-5.066,2.135-9.685-4.938c0,0,1.243-8.029-1.37-12.68s11.406,5.576,11.406,5.576-.223.956-.478,2.358c-.127.733-.255,1.561-.35,2.453-.064.733-.127,1.529-.159,2.294A12.922,12.922,0,0,0,2023.861,315.625Z",
    transform: "translate(-1995.054 -273.262)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6744",
    "data-name": "Path 6744",
    d: "M1987.953,390.3c-1.051,5.384-8.538,12.107-8.538,12.107-.382-1.083-.765-2.23-1.115-3.377A49.636,49.636,0,0,0,1987.953,390.3Z",
    transform: "translate(-1971.762 -336.978)",
    fill: "#393d63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7033",
    "data-name": "Group 7033",
    transform: "translate(1.093 40.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6745",
    "data-name": "Path 6745",
    d: "M1974.431,366.155c-.478,1.975-2.676,21.792-2.421,22.493.127.382,1.211,4.97,2.262,10.068h-9.781c-.988-3.282-1.593-6.022-1.466-7.551.637-6.691-1.657-28.037-1.657-28.037s-2.039-12.9,8.666-14.528c0,0,6.34.828,6.723,5.512C1977.171,358.8,1974.909,364.211,1974.431,366.155Z",
    transform: "translate(-1961.213 -348.6)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6746",
    "data-name": "Path 6746",
    d: "M1958.265,365.675l13.286,3.09s10.546-20.486,1.052-24.214C1962.6,340.633,1955.875,354.524,1958.265,365.675Z",
    transform: "translate(-1957.781 -305.344)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7036",
    "data-name": "Group 7036",
    transform: "translate(15.132 2.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7035",
    "data-name": "Group 7035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7034",
    "data-name": "Group 7034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6747",
    "data-name": "Path 6747",
    d: "M2021.277,231.961s11.565,4.237,4.237,24.182-22.27-3.409-20.008-15.643C2007.737,228.233,2021.277,231.961,2021.277,231.961Z",
    transform: "translate(-2005.276 -231.428)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7039",
    "data-name": "Group 7039",
    transform: "translate(14.685 1.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7038",
    "data-name": "Group 7038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7037",
    "data-name": "Group 7037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6748",
    "data-name": "Path 6748",
    d: "M2026.312,240.621a26.446,26.446,0,0,1-15.9,5.7,76.031,76.031,0,0,0-2.644,7.3s-9.654-16.6,1.434-24.978C2020.354,220.23,2030.422,237.148,2026.312,240.621Z",
    transform: "translate(-2003.874 -226.323)",
    fill: "#242424"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7042",
    "data-name": "Group 7042",
    transform: "translate(18.572 18.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7041",
    "data-name": "Group 7041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7040",
    "data-name": "Group 7040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6749",
    "data-name": "Path 6749",
    d: "M2020.065,283.873c0-1.466-.765-4.875-2.995-4.046s-.223,7.774,1.243,7.423C2018.313,287.25,2020.1,287.377,2020.065,283.873Z",
    transform: "translate(-2016.074 -279.698)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6750",
    "data-name": "Path 6750",
    d: "M2030.183,324.85c-5.416-1.5-7.519-6.691-7.583-6.85,4.428,5.7,7.742,4.875,7.742,4.875C2030.246,323.639,2030.246,324.085,2030.183,324.85Z",
    transform: "translate(-2001.949 -287.713)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7044",
    "data-name": "Group 7044",
    transform: "translate(1456.769 254.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6751-2",
    "data-name": "Path 6751",
    d: "M1973.421,323.232v1.784h10.45v9.813h1.784V323.264h-12.234ZM1902.532,334.8h1.784v-9.813h10.45V323.2h-12.2v11.6Zm81.339,50.562v9.813h-10.45v1.784h12.2V385.391h-1.752Zm-79.587,0H1902.5v11.565h12.2V395.14h-10.45v-9.781Z",
    transform: "translate(-1902.5 -323.2)",
    fill: "#4598e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7067",
    "data-name": "Group 7067",
    transform: "translate(1492.388 422.996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -435.97, -134.01)",
    filter: "url(#Path_6752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6752-2",
    "data-name": "Path 6752",
    d: "M2006.69,851.365H1888.224a14.015,14.015,0,0,1-14.024-14.024V693.424a14.015,14.015,0,0,1,14.024-14.024H2006.69a14.015,14.015,0,0,1,14.024,14.024V837.341A14.015,14.015,0,0,1,2006.69,851.365Z",
    transform: "translate(-1438.23 -533.64)",
    fill: "#fff",
    opacity: 0.95
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7045",
    "data-name": "Group 7045",
    transform: "translate(66.428 113.204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6415",
    "data-name": "Rectangle 6415",
    width: 11.629,
    height: 2.151,
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7046",
    "data-name": "Group 7046",
    transform: "translate(22.325 132.911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6416",
    "data-name": "Rectangle 6416",
    width: 67.625,
    height: 4.161,
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6417",
    "data-name": "Rectangle 6417",
    width: 54.676,
    height: 4.161,
    transform: "translate(0 20.012)",
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6418",
    "data-name": "Rectangle 6418",
    width: 32.047,
    height: 4.161,
    transform: "translate(0 10.006)",
    fill: "#96bfe6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7047",
    "data-name": "Group 7047",
    transform: "translate(23.482 28.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6753",
    "data-name": "Path 6753",
    d: "M2074.046,763.9v2.111h12.4V777.64h2.111V763.9ZM1989.9,777.64h2.11V766.011h12.4V763.9h-14.491v13.74Zm96.526,59.994v11.629h-12.4v2.111h14.491v-13.74Zm-94.416,0h-2.11v13.74h14.491v-2.111h-12.4V837.634Z",
    transform: "translate(-1989.9 -763.9)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7050",
    "data-name": "Group 7050",
    transform: "translate(103.163 132.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7048",
    "data-name": "Group 7048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6754",
    "data-name": "Path 6754",
    d: "M2394.9,1299.7a12.4,12.4,0,1,1,12.4-12.4A12.412,12.412,0,0,1,2394.9,1299.7Zm0-22.386a9.985,9.985,0,1,0,9.985,9.986A9.991,9.991,0,0,0,2394.9,1277.315Z",
    transform: "translate(-2382.5 -1274.9)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7049",
    "data-name": "Group 7049",
    transform: "translate(5.967 8.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6755",
    "data-name": "Path 6755",
    d: "M2417.542,1325.01l-5.642-5.622,1.7-1.7,3.938,3.937,5.52-5.52,1.685,1.7Z",
    transform: "translate(-2411.9 -1316.1)",
    fill: "#4598e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7066",
    "data-name": "Group 7066",
    transform: "translate(23.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7051",
    "data-name": "Group 7051",
    transform: "translate(2.293 47.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6756",
    "data-name": "Path 6756",
    d: "M2090.9,910.167h-7.063c-.122-.284-.223-.528-.325-.731-2.09-4.932-12.867-16.257-12.867-16.257v.061a.071.071,0,0,1-.021.041.9.9,0,0,0-.02.1c0,.02-.021.041-.021.061a.071.071,0,0,1-.02.041c-.447,1.644-2.618,9.864-3.694,16.683h-47.695c-.1-.629-.243-1.238-.385-1.786a38.552,38.552,0,0,1-.913-4.932c0-.081-.02-.162-.02-.223-.041-.284-.061-.568-.1-.853a46.387,46.387,0,0,1-.081-7.9c-.142.284-1.1,3.816-2.354,8.179-.69,2.4-1.482,5.033-2.253,7.53H2001.8l14.126-40.774c.3-.244,3.978-2.009,6.657-3.288,2.719-1.3,6.028-3.207,8.991-4.83,1.522-.832,2.963-1.583,4.2-2.151l.183-.081h0l3.43-1.563h0c.041,0,.365-.041.893-.081,2.862-.284,11.772-1.116,14.755-1.279.243-.02.446-.02.609-.041h.3a38.868,38.868,0,0,1,4.627,1.583c.1.041.183.061.284.1.122.041.223.081.345.122.2.081.427.162.629.244.426.162.873.345,1.319.528.162.061.3.122.467.182,4.831,1.908,10.351,4.282,11.67,5.236.873.629,3.572,5.723,6.718,12.015C2085.4,886.888,2089.538,902.475,2090.9,910.167Z",
    transform: "translate(-2001.8 -856.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7052",
    "data-name": "Group 7052",
    transform: "translate(39.69 31.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6757",
    "data-name": "Path 6757",
    d: "M2202.752,791.592c-.122,6.413-12.543,9.925-12.543,9.925s-5.2-6.515-3.958-7.124c.487-.244.69-1.218.751-2.314a21.8,21.8,0,0,0-.061-2.9c-.041-.446-.081-.751-.081-.751s1.766-1.867,4.039-4.1c3.938-3.9,9.356-8.89,9.377-6.9a3.647,3.647,0,0,1-.041.386C2199.281,782.256,2202.752,791.592,2202.752,791.592Z",
    transform: "translate(-2186.061 -776.974)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7053",
    "data-name": "Group 7053",
    transform: "translate(39.353 36.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6758",
    "data-name": "Path 6758",
    d: "M2196.659,802.7h0c-.02.041-.548.832-1.441,1.948-1.908,2.395-5.48,6.332-9.519,7.915a21.847,21.847,0,0,0-.061-2.9,8.568,8.568,0,0,1-1.238-.142,37.215,37.215,0,0,1,2.7-3.958l2.5-.751Z",
    transform: "translate(-2184.4 -802.7)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7054",
    "data-name": "Group 7054",
    transform: "translate(30.991 10.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6759",
    "data-name": "Path 6759",
    d: "M2166.192,695.061c-1.076,2.334-2.091,4.039-2.375,4.709h0a8.07,8.07,0,0,1-1.441,1.948c-2.05,2.212-5.845,5.115-9.58,5.013a8.553,8.553,0,0,1-1.238-.142,5.859,5.859,0,0,1-4.262-2.943c-7.753-15.161-2.131-27.561-2.131-27.561s21.168-5.987,24.477.386C2171.936,680.915,2168.708,689.581,2166.192,695.061Z",
    transform: "translate(-2143.196 -673.534)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7055",
    "data-name": "Group 7055",
    transform: "translate(30.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6760",
    "data-name": "Path 6760",
    d: "M2142.52,634.612s-1.969-.1-2.456-3.836c-.487-3.674.487-4.709.487-4.709s8.748-3.653,11.873-4.14c3.146-.467,10.858-.934,12.664,1.136,0,0,4.4-1.015,5.6,6.271,1.908,11.568-6.474,22.812-6.474,22.812s.081-7.57-1.6-8.565c-1.664-.994-3.105,1.38-3.105,1.38l-3.41.609s5.175-11.183-1.035-11.609C2148.873,633.577,2146.092,635.262,2142.52,634.612Z",
    transform: "translate(-2139.928 -621.527)",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7056",
    "data-name": "Group 7056",
    transform: "translate(49.921 17.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6761",
    "data-name": "Path 6761",
    d: "M2236.578,709.663c.325-3.329,6.352-4.607,5.947-1.116s-3.369,6.84-4.749,6.738C2236.416,715.163,2236.334,712.22,2236.578,709.663Z",
    transform: "translate(-2236.471 -706.47)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7057",
    "data-name": "Group 7057",
    transform: "translate(44.726 49.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6762",
    "data-name": "Path 6762",
    d: "M2251.449,882.433c-1.969-6.292-3.653-11.264-4.424-11.792-1.319-.954-11.771-3.816-16.724-5.764-.163-.061-.325-.122-.467-.183-.447-.183-.893-.345-1.319-.528-.223-.081-.426-.162-.629-.244-.122-.041-.223-.081-.345-.122a1.589,1.589,0,0,0-.284-.1l-.021.02a78.738,78.738,0,0,0-5.48,7c-5.135,7.286-11.812,19.1-10.777,30,.325,3.491.731,8.524,1.421,14.166.041.446.1.893.162,1.339H2235.7c.284-5.906.792-13.679,1.542-16.683a.071.071,0,0,1,.021-.041.075.075,0,0,1,.02-.061c0-.041.02-.061.02-.1a.071.071,0,0,1,.02-.041v-.041s5.6,8.747,5.886,16.967h14.552C2257.03,908.594,2254.8,893.23,2251.449,882.433Z",
    transform: "translate(-2210.872 -863.7)",
    fill: "#3c4145"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7058",
    "data-name": "Group 7058",
    transform: "translate(0 50.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6763",
    "data-name": "Path 6763",
    d: "M2026.89,870.881s-1.745,5.825-4,20.336h0c-.081.487-.162.974-.223,1.482,0,.061-.02.122-.02.183-.061.325-.1.67-.162,1.015,0,.041-.02.081-.02.122-.041.223-.081.467-.1.69-.081.568-.162,1.157-.264,1.745-.852,5.926-1.969,15.344-3.126,25.39h-9.153a46.114,46.114,0,0,1-.934-7.063.287.287,0,0,0-.041.122c-.731,2.03-1.542,4.221-2.354,6.373-.081.2-.142.386-.223.589H1990.5l15.709-41.078c.3-.244,4.364-2.415,7.022-3.694,2.8-1.339,6.312-2.963,9.438-4.4,1.5-.69,2.9-1.339,4.1-1.887Z",
    transform: "translate(-1990.5 -870.8)",
    fill: "#3c4145"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7059",
    "data-name": "Group 7059",
    transform: "translate(44.688 49.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6764",
    "data-name": "Path 6764",
    d: "M2223.635,879.592l-6.048,3.41,2.577,2.638-5.662,30.586h-2.131c-.791-6.19-1.238-11.731-1.583-15.506-1.583-16.866,15.242-35.862,16.277-37.019.812.3,1.685.649,2.578.995Z",
    transform: "translate(-2210.683 -863.7)",
    fill: "#51565c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7060",
    "data-name": "Group 7060",
    transform: "translate(26.384 50.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6765",
    "data-name": "Path 6765",
    d: "M2130.587,870.5s-2.253,7.367-4.891,25.755c-.852,5.926-1.989,15.344-3.125,25.39h-.893l-1.177-28.9,2.882-3.126-2.558-3.186,5.48-13.964c1.5-.69,2.9-1.339,4.1-1.887Z",
    transform: "translate(-2120.5 -870.5)",
    fill: "#51565c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7061",
    "data-name": "Group 7061",
    transform: "translate(43.839 46.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6766",
    "data-name": "Path 6766",
    d: "M2224.056,852.044,2219.043,849s-.142,2.74-12.543,9.925l3.511,9.925Z",
    transform: "translate(-2206.5 -849)",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7062",
    "data-name": "Group 7062",
    transform: "translate(36.471 47.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6767",
    "data-name": "Path 6767",
    d: "M2174.28,855.8s.2,2.963,3.308,8.544l-6.88,8.95-.507-14.532Z",
    transform: "translate(-2170.2 -855.8)",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7063",
    "data-name": "Group 7063",
    transform: "translate(39.678 56.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6768",
    "data-name": "Path 6768",
    d: "M2190.181,897.9s1.34,5.317.852,6.819c0,0-2.922,1.055-5.033-.264A23.663,23.663,0,0,1,2190.181,897.9Z",
    transform: "translate(-2186 -897.9)",
    fill: "#d44040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7064",
    "data-name": "Group 7064",
    transform: "translate(35.153 61.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6769",
    "data-name": "Path 6769",
    d: "M2170.806,936.807a135.182,135.182,0,0,0-.893,27.46h-5.865c-.081-1.157-.162-2.375-.223-3.633-1.1-18.956,5.6-35.883,5.6-35.883l2.984-.751C2172.409,924.02,2171.455,932.4,2170.806,936.807Z",
    transform: "translate(-2163.703 -924)",
    fill: "#d44040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7065",
    "data-name": "Group 7065",
    transform: "translate(15.808 74.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6770",
    "data-name": "Path 6770",
    d: "M2071.171,1000.985c-.223,4.546-.183,8.585-.183,8.585h0c0,.02,0,.142-.02.345,0-.081-.02-.162-.02-.223-.731,2.03-1.542,4.222-2.354,6.373a68.335,68.335,0,0,1-.183-6.941c.324-12.746,4.343-19.423,4.343-19.423C2071.82,991.912,2071.374,996.682,2071.171,1000.985Z",
    transform: "translate(-2068.388 -989.7)",
    fill: "#2d3133"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2977",
    "data-name": "Ellipse 2977",
    cx: 90,
    cy: 18,
    rx: 90,
    ry: 18,
    transform: "translate(1388.289 865.596)",
    fill: "#242424",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7090",
    "data-name": "Group 7090",
    transform: "translate(1373.152 483.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7068",
    "data-name": "Group 7068",
    transform: "translate(0 46.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6771",
    "data-name": "Path 6771",
    d: "M1700.894,1042.407l-37.117,20.406-37.277-58.648,45.07-15.666Z",
    transform: "translate(-1626.5 -988.5)",
    fill: "#3a3a3a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7069",
    "data-name": "Group 7069",
    transform: "translate(2.49 48.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6772",
    "data-name": "Path 6772",
    d: "M1702.274,1043.253l-34.747,19.081-34.827-54.872,42.138-14.662Z",
    transform: "translate(-1632.7 -992.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7094",
    "data-name": "Group 7094",
    transform: "translate(9.577 22.267) rotate(-24)",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6416-2",
    "data-name": "Rectangle 6416",
    width: 36.462,
    height: 2.243,
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6417-2",
    "data-name": "Rectangle 6417",
    width: 29.48,
    height: 2.243,
    transform: "translate(0 10.79)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6418-2",
    "data-name": "Rectangle 6418",
    width: 17.279,
    height: 2.243,
    transform: "translate(0 5.395)",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7095",
    "data-name": "Group 7095",
    transform: "translate(16.577 37.267) rotate(-24)",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6416-3",
    "data-name": "Rectangle 6416",
    width: 36.462,
    height: 2.243,
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6417-3",
    "data-name": "Rectangle 6417",
    width: 29.48,
    height: 2.243,
    transform: "translate(0 10.79)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6418-3",
    "data-name": "Rectangle 6418",
    width: 17.279,
    height: 2.243,
    transform: "translate(0 5.395)",
    fill: "#242424"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7070",
    "data-name": "Group 7070",
    transform: "translate(40.751 76.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6773",
    "data-name": "Path 6773",
    d: "M1771.954,1074.6s-6.467-3.093-9.279-4.7c-2.852-1.607-10.123-3.816-10.725-4.379-.6-.522-21.611-1.808-22.9-2.932s-2.531,2.571,2.932,3.776,13.055,4.1,13.457,6.226-5.583,2.651-6.226,4.379c-.6,1.767.161,1.366,1.044,1.727.843.362,7.15-3.093,9.922-2.129,2.772,1,6.99-.362,9.118.361s12.453,4.178,12.453,4.178Z",
    transform: "translate(-1727.947 -1062.377)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7071",
    "data-name": "Group 7071",
    transform: "translate(7.019 76.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6774",
    "data-name": "Path 6774",
    d: "M1672.425,1099.777s-5.423-4.9-8.074-6.949c-2.611-2.048-7.552-8.074-8.275-8.4-.723-.362-10.123-19.683-11.689-20.446-1.526-.763,1.446-3.374,4.7,1.285s8.958,10.685,11.127,10.243.321-6.307,1.727-7.552,1.366-.362,2.049.281-.161,7.954,1.848,10.163,2.37,6.749,3.856,8.476,8.8,10.083,8.8,10.083Z",
    transform: "translate(-1643.974 -1062.566)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7072",
    "data-name": "Group 7072",
    transform: "translate(152.363 373.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6775",
    "data-name": "Path 6775",
    d: "M2005.8,1803.585s1.165,8.154,1.326,9.359,13.055-.723,13.055-.723l1.044-9.721C2021.225,1802.54,2007.407,1802.46,2005.8,1803.585Z",
    transform: "translate(-2005.8 -1802.5)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7073",
    "data-name": "Group 7073",
    transform: "translate(131.159 382.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6776",
    "data-name": "Path 6776",
    d: "M1975.423,1825.222s-4.1,4.9-8.034,7.07c-3.977,2.129-10.163,2.972-12.533,5.222-1.687,1.607-6.146,8.476,10.283,8.355s24.343.964,26.11-1.687-2.531-19.482-2.531-19.482S1984.823,1826.066,1975.423,1825.222Z",
    transform: "translate(-1953.014 -1824.7)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7074",
    "data-name": "Group 7074",
    transform: "translate(59.812 373.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6777",
    "data-name": "Path 6777",
    d: "M1775.4,1803.585s1.165,8.154,1.326,9.359,13.055-.723,13.055-.723l1.044-9.721C1790.865,1802.54,1777.047,1802.46,1775.4,1803.585Z",
    transform: "translate(-1775.4 -1802.5)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7075",
    "data-name": "Group 7075",
    transform: "translate(31.044 382.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6778",
    "data-name": "Path 6778",
    d: "M1733.756,1825.162s-4.1,4.9-8.034,7.07c-3.977,2.129-18.518,3.9-20.848,6.106-1.687,1.607-4.5,8.034,18.639,7.431,16.429-.442,24.343.964,26.11-1.687s-2.531-19.482-2.531-19.482S1743.4,1826.086,1733.756,1825.162Z",
    transform: "translate(-1703.782 -1824.6)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7076",
    "data-name": "Group 7076",
    transform: "translate(112.102 165.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6779",
    "data-name": "Path 6779",
    d: "M1935.148,1283.9s12.131,19.281,11.247,36.715c-.924,17.434,4.419,36.474,6.226,54.671,2.049,20.286,10.364,68.328,10.645,79.214.321,10.846-1.285,45.512-1.285,45.512l-16.63.362s-13.979-83.995-17.594-92.591c-3.615-8.556-21.571-69.694-22.174-76.523C1904.9,1324.431,1935.148,1283.9,1935.148,1283.9Z",
    transform: "translate(-1905.572 -1283.9)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7077",
    "data-name": "Group 7077",
    transform: "translate(57.603 162.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6780",
    "data-name": "Path 6780",
    d: "M1790.105,1281.573s-9.159,47.762-10.364,58.447-2.008,51.618-2.611,58.286-4.017,87.248-7.23,97.13h21.29s16.349-58.567,16.349-86.284,12.613-60.254,20.768-78.531S1855.1,1311.9,1860.121,1278C1860.081,1278,1796.854,1270.807,1790.105,1281.573Z",
    transform: "translate(-1769.9 -1275.646)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7078",
    "data-name": "Group 7078",
    transform: "translate(92.438 1.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6781",
    "data-name": "Path 6781",
    d: "M1885.615,878.186s-16.269-6.066-23.78,6.307-6.789,37.237,1.406,40.29,20.527,1.446,24.744-6.307,7.994-18.96,7.833-26.472C1895.617,884.492,1889.873,880.355,1885.615,878.186Z",
    transform: "translate(-1856.62 -876.699)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7079",
    "data-name": "Group 7079",
    transform: "translate(100.342 35.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6782",
    "data-name": "Path 6782",
    d: "M1876.78,974.762s.683,4.378-.442,6.548,21.089,2.209,21.089,2.209a147.248,147.248,0,0,1,5.222-21.732C1906.064,951.865,1876.78,974.762,1876.78,974.762Z",
    transform: "translate(-1876.297 -959.294)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7080",
    "data-name": "Group 7080",
    transform: "translate(93.099 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6783",
    "data-name": "Path 6783",
    d: "M1891.861,909.648s-1.526,2.531-7.793,1.567-13.9-9.319-16.51-10.243-2.651-2.45-2.651-2.45l-1.647,2.41-2.772.161s2.531-7.431-1.286-10.484,3.977-24.1,24.062-17.112c0,0,15.425,4.258,14.863,13.015S1895.316,905.269,1891.861,909.648Z",
    transform: "translate(-1858.266 -872.082)",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7081",
    "data-name": "Group 7081",
    transform: "translate(99.058 50.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6784",
    "data-name": "Path 6784",
    d: "M1873.1,1004.438s.08-4.137,1.928-4.539c1.888-.4,20.728-2.209,23.017-1.285v4.82S1893.627,1006.165,1873.1,1004.438Z",
    transform: "translate(-1873.1 -998.354)",
    fill: "#106f98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7082",
    "data-name": "Group 7082",
    transform: "translate(99.668 20.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6785",
    "data-name": "Path 6785",
    d: "M1875.133,925.144c.362-1.486,4.1-5.664,5.543-1.165s-2.169,10.565-4.178,10.042C1874.45,933.5,1874.209,928.88,1875.133,925.144Z",
    transform: "translate(-1874.618 -921.952)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7083",
    "data-name": "Group 7083",
    transform: "translate(24.227 105.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6786",
    "data-name": "Path 6786",
    d: "M1686.887,1135.2h0C1686.807,1135.28,1686.766,1135.28,1686.887,1135.2Z",
    transform: "translate(-1686.811 -1135.2)",
    fill: "#323657"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7084",
    "data-name": "Group 7084",
    transform: "translate(24.383 55.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6787",
    "data-name": "Path 6787",
    d: "M1818.193,1166.517s-10,2.932-27.034,4.82-59.612-.683-59.853-2.691c-.281-2.008,9.159-74.916,8.636-78.692-.522-3.736-.844-17.152-.844-17.152-.2,3.655-3.937,18.639-8.436,26.793-1.647,2.932-7.11,12.212-9.721,10.083-12.734-10.163-32.5-48.525-33.742-48.846,1.044-.442,9.359-4.3,10.524-4.66,1-.321,10.2,9.4,15.787,15.425,2.49,2.691,4.258,4.66,4.258,4.66,1.607-3.615,7.472-26.432,9.279-34.345,4.1-17.8,3.495-18.558,3.495-18.558,12.452-3.776,31.372-11.448,31.372-11.448l24.945-1s22.9,5.061,31.935,9.118c.844.4.844,20.446,3.214,25.709l-7.472,15.787s-4.338,31.252-5.222,45.151C1808.874,1113.051,1818.193,1166.517,1818.193,1166.517Z",
    transform: "translate(-1687.2 -1010.9)",
    fill: "#2281ab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7085",
    "data-name": "Group 7085",
    transform: "translate(132.425 64.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6788",
    "data-name": "Path 6788",
    d: "M1983.937,1085.338c-.643,2.089-3.615,3.9-5.543,4.66a7.415,7.415,0,0,1-3.977.4l-.964-.2h0l-17.112-3.174s-3.736-43.1,23.379-53.425C1980.4,1033.841,1989.922,1066.057,1983.937,1085.338Z",
    transform: "translate(-1956.166 -1033.6)",
    fill: "#2281ab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7086",
    "data-name": "Group 7086",
    transform: "translate(149.712 99.467)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6789",
    "data-name": "Path 6789",
    d: "M2004.141,1141.512h0a7.417,7.417,0,0,1-3.977.4l-.964-.2h0l1.687-22.013Z",
    transform: "translate(-1999.2 -1119.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7087",
    "data-name": "Group 7087",
    transform: "translate(50.652 116.459)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6790",
    "data-name": "Path 6790",
    d: "M1756.855,1166.66l-2.089,8.837s-2.25-8.877-2.169-13.5C1755.087,1164.691,1756.855,1166.66,1756.855,1166.66Z",
    transform: "translate(-1752.595 -1162)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7088",
    "data-name": "Group 7088",
    transform: "translate(126.052 4.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6791",
    "data-name": "Path 6791",
    d: "M1940.3,883.931s21.33-2.691.362,32.979Z",
    transform: "translate(-1940.3 -883.885)",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7089",
    "data-name": "Group 7089",
    transform: "translate(14.983 49.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6792",
    "data-name": "Path 6792",
    d: "M1665.969,1005.341l-2.169-3.736,17.112-5.9,2.169,3.7Z",
    transform: "translate(-1663.8 -995.7)",
    fill: "#3a3a3a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorlog);
export default __webpack_public_path__ + "static/media/visitorlog.4f0c278d2861f5fbe160f6f5587b24a7.svg";
export { ForwardRef as ReactComponent };